import React, { useState, useEffect } from "react";
import { getLeaderboard } from "../config/adventUtils";
import Leaderboard from "./Leaderboard";

function HighScore({ currentUserId = null }) {
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const fetchLeaderboard = async () => {
    const data = await getLeaderboard(100); // Fetch all to find user's position
    setLeaderboard(data);
    setLoading(false);
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 mt-6">
        <h2 className="text-2xl font-bold text-center mb-4 text-gray-800">
          Resultatliste
        </h2>
        <p className="text-center text-gray-600">Laster...</p>
      </div>
    );
  }

  return (
    <Leaderboard
      leaderboard={leaderboard}
      currentUserId={currentUserId}
      title="🏆 Resultatliste 🏆"
      emptyMessage="Ingen spillere ennå. Vær den første!"
      scoreLabel="totalScore"
    />
  );
}

export default HighScore;
